import channelApi from "@/api/ChannelApi";

const ChannelStore = {
  namespaced: true,
  state: {
    allChannelList: null,
  },
  mutations: {
    setAllChannelList(state, data) {
      if (data == null) {
        state.allChannelList = null;
      } else {
        state.allChannelList = data.items.map((item) => {
          return { label: item.channelName, value: item.channelCode };
        });
      }
    },
  },
  actions: {
    listAllChannel(ctx, isUpdate) {
      if (!isUpdate && ctx.state.allChannelList != null) {
        return Promise.resolve(ctx.state.allChannelList);
      }
      return channelApi
        .listChannel({
          request: JSON.stringify({
            pageInfo: {
              pageIndex: 1,
              pageSize: 100000,
            },
          }),
        })
        .then((res) => {
          ctx.commit("setAllChannelList", res);
          return ctx.state.allChannelList;
        });
    },
    listChannel(ctx, data) {
      return channelApi.listChannel(data);
    },
    addOrModifyChannel(ctx, data) {
      return channelApi.addOrModifyChannel(data).then((res) => {
        ctx.dispatch("listAllChannel", true);
        return res;
      });
    },
    deleteChannel(ctx, data) {
      return channelApi.deleteChannel(data).then((res) => {
        ctx.dispatch("listAllChannel", true);
        return Promise.resolve(res);
      });
    },
  },
};

export default ChannelStore;
